// extracted by mini-css-extract-plugin
module.exports =  {"infoBlock":"mmcVzmvi86xnrjxgH8ik"};